import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'

export const useInfoComponentStyles = makeStyles((theme: Theme) =>
  createStyles({
    infoBlock: {
      padding: theme.spacing(0, 0, 1, 0),
      [theme.breakpoints.down('xs')]: {
        paddingTop: theme.spacing(1),
      },
    },
    listingTitle: {
      marginBottom: theme.spacing(0.75),
    },
    listedTimeBlock: {
      marginBottom: theme.spacing(1.25),
    },
    listedDateValue: {
      fontWeight: 600,
    },
    sectionTitle: {
      margin: 0,
      marginBottom: theme.spacing(1.25),
      marginTop: theme.spacing(0.5),
      fontWeight: theme.typography.fontWeightBold as any,
    },
    divider: {
      margin: theme.spacing(3, 0),
    },
    /** Skeleton layout only — tighter vertical rhythm */
    loadingDivider: {
      margin: theme.spacing(1.25, 0),
    },
    loadingPriceRow: {
      marginBottom: theme.spacing(0.5),
    },
    loadingDeliveryBlock: {
      marginBottom: theme.spacing(0.5),
    },
    loadingSkeletonHeading: {
      marginBottom: theme.spacing(1),
    },
    loadingDescriptionStack: {
      '& > *:not(:first-child)': {
        marginTop: theme.spacing(0.5),
      },
    },
    loadingDetailsGrid: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
    loadingDetailRow: {
      display: 'grid',
      gridTemplateColumns: 'minmax(120px, 38%) 1fr',
      gap: theme.spacing(0.75),
      alignItems: 'start',
      [theme.breakpoints.down('xs')]: {
        gridTemplateColumns: '1fr',
        gap: theme.spacing(0.25),
      },
    },
    ctaSection: {
      marginBottom: theme.spacing(0.75),
    },
    priceRow: {
      marginBottom: theme.spacing(1),
    },
    deliveryBlock: {
      marginBottom: theme.spacing(1),
      '& .MuiFormGroup-root': {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: theme.spacing(2, 3),
      },
      '& .MuiFormControlLabel-root': {
        margin: 0,
      },
    },
    ownerItemAlert: {
      width: '100%',
      marginTop: theme.spacing(0.5),
    },
    statusMessageBlock: {
      display: 'block',
      marginTop: theme.spacing(1.5),
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
    },
    detailsGrid: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    detailRow: {
      display: 'grid',
      gridTemplateColumns: 'minmax(120px, 38%) 1fr',
      gap: theme.spacing(1),
      alignItems: 'start',
      [theme.breakpoints.down('xs')]: {
        gridTemplateColumns: '1fr',
        gap: theme.spacing(0.35),
      },
    },
    /** Detail value column: smaller (body2) + heavier weight from theme */
    detailValue: {
      wordBreak: 'break-word',
      fontWeight: 600,
    },
    descriptionMeasure: {
      overflow: 'hidden',
      position: 'absolute',
      zIndex: -1,
    },
    descriptionHolder: {
      overflowY: 'hidden',
    },
    wasSoldLabel: {
      fontStyle: 'italic',
      display: 'flex',
      alignItems: 'center',
      marginTop: theme.spacing(2),
    },
    /** Sold state banner (replaces plain italic line) */
    soldStateAlert: {
      width: '100%',
      marginTop: theme.spacing(2),
      '& .MuiAlert-message': {
        fontStyle: 'italic',
      },
    },
  })
)
